import React from "react";
import DatePickerSample from "../../DatePicker";
import { ImageUrlPrefix } from "../../../../labels";

const FacultyProfileStep1 = ({
  list,
  listErrors,
  handleChange,
  styles,
  txtAdPpath,
  txtAdFname,
  txtAdLname,
  txtAdFath,
  txtAdMDob,
  handleChangeDate,
  txtAdAge,
  txtAdPlaceBrith,
  txtAdGender,
  txtAdMStatus,
  txtAdSpouse,
  txtAdOccupation,
  txtAdPno,
  txtAdWno,
  txtAdEmail,
  txtAdPSize,
  txtAdAno,
  txtAdpno,
  txtAdApath,
}) => {
  return (
    <div className="PersonalProfileForm">
      {/* Basic Details */}
      <fieldset className="mt-3">
        <legend className="w-auto">Basic Details</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="FirstName" className="form-label confirm_value">
              First Name
            </label>
            <input
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              ref={txtAdFname}
              type="text"
              id="FirstName"
              name="FirstName"
              placeholder="Enter the first name"
              value={list.FirstName}
              onChange={handleChange}
            />
            {listErrors.FirstName && (
              <small className="error_message">{listErrors.FirstName}</small>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="LastName" className="form-label confirm_value">
              Last Name
            </label>
            <input
              ref={txtAdLname}
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              type="text"
              id="LastName"
              name="LastName"
              placeholder="Enter the last name"
              value={list.LastName}
              onChange={handleChange}
            />
            {listErrors.LastName && (
              <small className="error_message">{listErrors.LastName}</small>
            )}
          </div>

          <div class="col-md-6">
            <label for="Fathername" class="form-label confirm_value ">
              Father's Name/Guardian's Name
            </label>
            <input
              ref={txtAdFath}
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              type="text"
              id="Fathername"
              name="Fathername"
              placeholder="Enter the father's name/guardian's name"
              value={list.Fathername}
              onChange={handleChange}
            />
            {listErrors.Fathername && (
              <small className="error_message">{listErrors.Fathername}</small>
            )}
          </div>
          <div className="col-md-6">
            <label htmlFor="DOB" className="form-label confirm_value">
              Date of Birth
            </label>
            <DatePickerSample
              txtAdMDob={txtAdMDob}
              name={"DOB"}
              handleChange={handleChangeDate}
              fieldInput={list.DOB}
            />
            {listErrors.DOB && (
              <small className="error_message">{listErrors.DOB}</small>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="age" className="form-label confirm_value">
              Age
            </label>
            <input
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              ref={txtAdAge}
              id="age"
              type="text"
              name="age"
              readOnly
              onChange={handleChange}
              value={list.age}
              placeholder="Age"
              autoComplete="age"
              required
              disabled
            />
            {listErrors.age && (
              <small className="errors">{listErrors.age}</small>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="age" className="form-label confirm_value">
              Place of Birth
            </label>

            <input
              ref={txtAdPlaceBrith}
              id="PlaceBirth"
              type="text"
              name="PlaceBirth"
              onChange={handleChange}
              value={list.PlaceBirth}
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              placeholder="Place of Birth"
              autoComplete="Place of Birth"
              required
            />
            {listErrors.PlaceBirth && (
              <small className="error_message">{listErrors.PlaceBirth}</small>
            )}
          </div>

          <div className="col-md-6">
            <label htmlFor="Gender" className="form-label confirm_value">
              Gender
            </label>
            <div>
              {["Male", "Female", "Transgender"].map((option) => (
                <React.Fragment key={option}>
                  <input
                    className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                    type="radio"
                    id={option}
                    ref={txtAdGender}
                    name="gender"
                    value={option}
                    checked={list.gender === option}
                    onChange={handleChange}
                  />
                  <label
                    className="form-label confirm_value me-3"
                    htmlFor={option}
                  >
                    {option}
                  </label>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="col-md-6">
            <label htmlFor="MaritalStatus" className="form-label confirm_value">
              Marital Status
            </label>
            <div>
              {["Single/Unmarried", "Married", "Widowed"].map((option) => (
                <React.Fragment key={option}>
                  <input
                    className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                    type="radio"
                    id={option}
                    ref={txtAdMStatus}
                    name="MaritalStatus"
                    value={option}
                    checked={list.MaritalStatus === option}
                    onChange={handleChange}
                  />
                  <label
                    className="form-label confirm_value me-3"
                    htmlFor={option}
                  >
                    {option}
                  </label>
                </React.Fragment>
              ))}
            </div>
          </div>

          {list.MaritalStatus !== "Single/Unmarried" &&
            list.MaritalStatus !== "Widowed" && (
              <>
                <div className="col-md-6">
                  <label htmlFor="Spouse" className="form-label confirm_value">
                    Name of the Spouse
                  </label>
                  <input
                    ref={txtAdSpouse}
                    id="Spouse"
                    type="text"
                    name="Spouse"
                    onChange={handleChange}
                    value={list.Spouse}
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    placeholder="Name of the Spouse"
                    autoComplete="Spouse"
                    required
                  />
                  {listErrors.Spouse && (
                    <small className="error_message">{listErrors.Spouse}</small>
                  )}
                </div>

                <div className="col-md-6">
                  <label
                    htmlFor="Occupation"
                    className="form-label confirm_value"
                  >
                    Occupation of the Spouse
                  </label>
                  <input
                    ref={txtAdOccupation}
                    id="Occupation"
                    type="text"
                    name="Occupation"
                    onChange={handleChange}
                    value={list.Occupation}
                    className="desc_input_text w-100 rounded-2 input-font-size-sm"
                    placeholder="Occupation of the Spouse"
                    autoComplete="Occupation"
                    required
                  />
                  {listErrors.Occupation && (
                    <small className="error_message">
                      {listErrors.Occupation}
                    </small>
                  )}
                </div>
              </>
            )}
        </form>
      </fieldset>

      {/* Contact Details */}
      <fieldset className="mt-3">
        <legend className="w-auto">Contact Details</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label htmlFor="FirstName" className="form-label confirm_value">
              Phone Number
            </label>
            <input
              ref={txtAdPno}
              id="Mobile"
              type="tel"
              name="Mobile"
              onChange={handleChange}
              value={list.Mobile}
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              placeholder="Phone Number"
              autoComplete="Mobile"
              required
              minLength={10}
              maxLength={10}
              inputMode="tel"
            />
            {listErrors.Mobile && (
              <small className="error_message">{listErrors.Mobile}</small>
            )}
          </div>

          <div className="col-md-6">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label
                htmlFor="WhatsAppNumber"
                className="form-label confirm_value mb-0"
              >
                WhatsApp Number
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="checkbox"
                  id="ContactNumber"
                  name="ContactNumber"
                  onChange={handleChange}
                  value={list.ContactNumber}
                  checked={list.ContactNumber === true}
                  className="form-check-input"
                />
                <label
                  htmlFor="ContactNumber"
                  className="form-label confirm_value ms-2 mb-0"
                >
                  Same as Contact Number
                </label>
              </div>
            </div>

            <input
              ref={txtAdWno}
              id="WhatsAppNumber"
              type="tel"
              name="WhatsAppNumber"
              placeholder="WhatsApp Number"
              minLength={10}
              maxLength={10}
              className="desc_input_text w-100 rounded-2 input-font-size-sm"
              onChange={handleChange}
              value={
                list.ContactNumber !== true ? list.WhatsAppNumber : list.Mobile
              }
              autoComplete="WhatsAppNumber"
              required
              inputMode="tel"
            />
            {listErrors.WhatsAppNumber && (
              <small className="error_message">
                {listErrors.WhatsAppNumber}
              </small>
            )}
          </div>

          <div class="col-md-6">
            <label for="Fathername" class="form-label confirm_value ">
              Email ID
            </label>
            <input
              ref={txtAdEmail}
              id="emailaddress"
              type="email"
              readOnly
              disabled
              name="emailaddress"
              class={`desc_input_text w-100 rounded-2 input-font-size-sm
                             `}
              onChange={handleChange}
              value={list.emailaddress}
              placeholder=" Email ID"
              autoComplete="emailaddress"
              required
            />
            {listErrors.emailaddress && (
              <small className="error_message">{listErrors.emailaddress}</small>
            )}
          </div>
        </form>
      </fieldset>

      {/* passport photograph */}
      <fieldset className="mt-3">
        <legend className="w-auto">Passport Size Photograph</legend>
        <form className="row g-3">
          {/* Displaying uploaded profile image */}
          <div className="col-md-6 d-flex justify-content-center">
            <div className="position-relative text-center">
              {list.Profilephoto ? (
                <img
                  className={`${styles.ProfilePhoto} bg-opacity-75`}
                  src={`${ImageUrlPrefix}/${list.Profilephoto}`}
                  alt="Profile"
                />
              ) : (
                <div
                  className={`${styles.ProfilePhoto} d-flex align-items-center justify-content-center bg-opacity-75`}
                >
                  <span id="text">Profile Picture</span>
                </div>
              )}
            </div>
          </div>

          {/* Upload section */}
          <div className="col-md-6">
            <label htmlFor="Profilephoto" className="form-label confirm_value">
              Upload Passport Size Photograph
            </label>
            <div className="row d-flex align-items-center">
              <div>
                <input
                  ref={txtAdPSize}
                  id="Profilephoto"
                  type="file"
                  name="Profilephoto"
                  onChange={handleChange}
                  autoComplete="Profilephoto"
                  required
                  className="InputsSelectFile m-0"
                  accept="image/jpeg,image/png"
                />
              </div>
              {list.Profilephoto !== "" && list.Profilephoto !== null && (
                <div className="mt-1">
                  <span className="m-0">
                    {list.Profilephoto !== "" && list.Profilephoto !== null
                      ? list.original_profile_path
                      : ""}
                  </span>
                </div>
              )}
              {/* Error display */}
              {listErrors.Profilephoto && (
                <small className="error_message">
                  {listErrors.Profilephoto}
                </small>
              )}
            </div>

            {/* Note section */}
            <div className="Note mt-3">
              <h6 className={styles.profileNote}>Note</h6>
              <p className={styles.noteOne}>
                <span className={styles.note_subheader}>Image format: </span>
                The recommended image format for profile pictures on Anna IAS
                Academy is JPEG or PNG.
              </p>
              <p className={styles.noteOne}>
                <span className={styles.note_subheader}>Image size: </span>
                Profile pictures should be a minimum of 400x400 pixels and a
                maximum of 1024x1024 pixels. The file size should not exceed 40
                KB.
              </p>
              <p className={styles.noteOne}>
                <span className={styles.note_subheader}>
                  Image quality and content:{" "}
                </span>
                Choose a clear and high-quality image for your profile picture.
                Your profile picture should be appropriate and professional.
              </p>
              <p className={styles.noteOne}>
                <span className={styles.note_subheader}>
                  Image orientation:{" "}
                </span>
                Profile pictures should be in a square format, as they will be
                displayed as a circle on the platform. Make sure your image is
                not stretched or distorted.
              </p>
            </div>
          </div>
        </form>
      </fieldset>

      {/* ID Proofs */}
      <fieldset className="mt-3">
        <legend className="w-auto">ID Proofs</legend>
        <form className="row g-3">
          <div className="col-md-6">
            <label for="aadharNo" class="form-label confirm_value">
              AADHAR Number
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm
                                 `}
              type="number"
              ref={txtAdAno}
              id="aadharNo"
              name="aadharNo"
              placeholder="Enter the aadhar number"
              required
              minLength={12}
              autoComplete="aadharNo"
              value={list.aadharNo < 0 ? 0 : list.aadharNo}
              onChange={handleChange}
            />
            {listErrors.aadharNo && (
              <small className="error_message">{listErrors.aadharNo}</small>
            )}
          </div>
          <div className="col-md-6">
            <label
              htmlFor="aadharCardphoto"
              className="form-label confirm_value"
            >
              Upload AADHAR Card (In pdf/Image format)
              {list.aadharCardphoto !== "" && list.aadharCardphoto !== null && (
                <a
                  href={`${ImageUrlPrefix}/${list.aadharCardphoto}`}
                  target="_blank"
                  download
                >
                  <span className="material-icons download_icon align-middle text-danger ">
                    file_download
                  </span>
                </a>
              )}
            </label>
            <div className="row d-flex align-items-center">
              <div>
                <input
                  className="InputsSelectFile m-0"
                  ref={txtAdApath}
                  id="aadharCardphoto"
                  type="file"
                  name="aadharCardphoto"
                  placeholder="Upload AADHAR Card"
                  onChange={handleChange}
                  autoComplete="aadharCardphoto"
                  required
                />
              </div>
              {list.aadharCardphoto !== "" && list.aadharCardphoto !== null && (
                <div className="mt-1">
                  <span className="">
                    {list.aadharCardphoto !== "" &&
                    list.aadharCardphoto !== null
                      ? list.original_aadhar_path
                      : ""}
                  </span>
                </div>
              )}
            </div>
            {listErrors.aadharCardphoto && (
              <small className="error_message">
                {listErrors.aadharCardphoto}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label for="aadharNo" class="form-label confirm_value">
              PAN Number
            </label>
            <input
              class={`desc_input_text w-100 rounded-2 input-font-size-sm`}
              ref={txtAdpno}
              id="panNo"
              type="text"
              name="panNo"
              onChange={handleChange}
              value={list.panNo < 0 ? 0 : list.panNo}
              placeholder="PAN Number"
              autoComplete="panNo"
              required
            />
            {listErrors.panNo && (
              <small className="error_message">{listErrors.panNo}</small>
            )}
          </div>
          <div className="col-md-6">
            <label
              htmlFor="aadharCardphoto"
              className="form-label confirm_value"
            >
              Upload PAN Card (In pdf/Image format)
              {list.panPhoto !== "" && list.panPhoto !== null && (
                <a
                  href={`${ImageUrlPrefix}/${list.panPhoto}`}
                  target="_blank"
                  download
                >
                  <span className="material-icons download_icon align-middle text-danger ">
                    file_download
                  </span>
                </a>
              )}
            </label>
            <div className="row d-flex align-items-center">
              <div>
                <input
                  ref={txtAdPpath}
                  id="panPhoto"
                  type="file"
                  name="panPhoto"
                  placeholder="Upload pan Card"
                  className="InputsSelectFile m-0"
                  onChange={handleChange}
                  autoComplete="panPhoto"
                  required
                />
              </div>
              {list.panPhoto !== "" && list.panPhoto !== null && (
                <div className="mt-1">
                  <span className="">
                    {list.panPhoto !== "" && list.panPhoto !== null
                      ? list.original_aadhar_path
                      : ""}
                  </span>
                </div>
              )}
            </div>
            {listErrors.panPhoto && (
              <small className="error_message">{listErrors.panPhoto}</small>
            )}
          </div>
        </form>
      </fieldset>
    </div>
  );
};

export default FacultyProfileStep1;
